// src/components/layout/RequireUser.jsx
import React from 'react';
import { useOutletContext } from 'react-router-dom';
import styles from './RequireUser.module.css';

const RequireUser = ({ children }) => {
  const context = useOutletContext();
  const { user } = context || {};

  // If user is not yet loaded, show loading
  if (!user) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingContent}>
          <div className={styles.spinner}></div>
          <p className={styles.loadingText}>Loading...</p>
        </div>
      </div>
    );
  }

  // User is loaded, render children
  return children;
};

export default RequireUser;